<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center">
      <PageHeader class="text-lg font-medium mr-auto" title="Өндөрлөсөн" />
    </div>
    <div class="intro-y mt-5 overflow-auto lg:overflow-visible">
      <ReportEndDayTable
        :loading="isLoading"
        :rows="reportLoanList"
        :columns="columns"
        :sort="sort"
        :page="page"
        :per-page="perPage"
        :page-size="pageSize"
        :total-page="totalPage"
        :total-records="totalRecords"
        :custom-filters="customFilters"
        :downloadable="true"
        @onFilter="onFilter"
        @onPageChange="onPageChange"
        @onPerPageChange="onPerPageChange"
        @onSortChange="onSortChange"
        @onChangeCustomFilter="onChangeCustomFilter"
        @onDownload="onDownload"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { REPORT_END_DAY_REQUEST, REPORT_END_DAY_EXPORT } from '@/store/actions/report';
import PageHeader from '@/components/ui/PageHeader';
import ReportEndDayTable from '@/components/report/ReportEndDayTable';
import dataListMixin from '@/mixins/dataListMixin';

export default {
  mixins: [dataListMixin],

  components: {
    PageHeader,
    ReportEndDayTable,
  },

  data() {
    return {
      storeActionListRequest: REPORT_END_DAY_REQUEST,
      storeActionDownload: REPORT_END_DAY_EXPORT,
      columns: [
        // bank
        { label: this.$t('table.date'), field: 'endDate' },
        { label: 'Олголт', field: 'bankExpense' },
        { label: 'Төлөлт', field: 'bankIncome' },
        { label: 'Олголт тоо', field: 'bankExpenseCount' },
        { label: 'Төлөлт тоо', field: 'bankIncomeCount' },
        // system
        { label: 'Олголт', field: 'totalLoanIssuedAmount' },
        { label: 'Төлөлт', field: 'totalLoanPaidAmount' },
        { label: 'Олголт тоо', field: 'totalLoanIssuedCount' },
        { label: 'Төлөлт тоо', field: 'totalLoanPaidCount' },
        // olgolt zadargaa
        { label: 'Олголт', field: 'totalLoanIssuedAmount' },
        { label: 'Шимтгэл', field: 'feeIncome' },
        // tulult zadargaa
        { label: 'С.Шимтгэл', field: 'extendedFeeIncome' },
        { label: 'Хүү +', field: 'increaseInterestIncome' },
        { label: 'Хүү', field: 'interestIncome' },
        { label: 'Ү.Төлөлт', field: 'uTulult' },
        { label: 'Илүү төлөлт', field: 'overPayment' },
      ],
      customFilters: [
        {
          key: 'startDate',
          value: null,
          label: this.$t('text.selectStartDate'),
          type: 'day',
        },
        {
          key: 'endDate',
          value: null,
          label: this.$t('text.selectEndDate'),
          type: 'day',
        },
      ],
    };
  },

  computed: {
    ...mapGetters([
      'reportLoanList',
      'reportLoanListStatus',
      'reportLoanListMeta',
      'reportLoanExportStatus',
      'reportLoanExportLink',
    ]),
    isLoading() {
      return this.reportLoanListStatus === 'loading';
    },
    isDownloading() {
      return this.reportLoanExportStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters['filter[status]'] = true;
      this.customFilters.forEach(item => {
        data.filters[`filter[${item.key}]`] = item.value;
      });
    },
    setPaginationValues() {
      this.totalRecords = this.reportLoanListMeta ? this.reportLoanListMeta.total : 1;
      this.page = this.reportLoanListMeta.currentPage;
      this.totalPage = this.reportLoanListMeta.lastPage;
    },
    onChangeCustomFilter(object) {
      const index = this.customFilters.findIndex(item => item.key === object.key);
      if (index > -1) {
        const { value } = object;
        this.customFilters[index].value = value || null;
        this.page = 1;
        this.fetchData();
      }
    },
    setDownloads() {
      if (this.reportLoanExportStatus === 'success') {
        window.open(`${this.reportLoanExportLink}`, '_blank');
      }
    },
  },
};
</script>
